"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamHandle = void 0;
const memoizee_1 = __importDefault(require("memoizee"));
class TeamHandle {
    constructor(team) {
        this.getTeamTypes = (0, memoizee_1.default)(() => new Set(this.type));
        this.getProductTypes = (0, memoizee_1.default)(() => new Set(this.productTypes || []));
        Object.assign(this, team);
        if (!this.teams) {
            this.teams = { enabled: false };
        }
    }
    getMsTeamId() {
        return this.msTeamId && this.msTeamId.length > 0 ? this.msTeamId : undefined;
    }
    getOffboardingDate() {
        return typeof this.offboardingDate?.year === "number" &&
            typeof this.offboardingDate?.month === "number" &&
            typeof this.offboardingDate?.day === "number"
            ? new Date(this.offboardingDate.year, this.offboardingDate.month, this.offboardingDate?.day)
            : undefined;
    }
    isOffboarded(now = new Date()) {
        const offboarding = this.getOffboardingDate();
        return !!offboarding && offboarding.getTime() <= now.getTime();
    }
    hasTeamType(type) {
        return this.getTeamTypes().has(type);
    }
    hasProductType(type) {
        return this.getProductTypes().has(type);
    }
    compare(other) {
        return (this.name || "")
            .toLowerCase()
            .localeCompare((other.name || "").toLowerCase());
    }
}
exports.TeamHandle = TeamHandle;
//# sourceMappingURL=TeamHandle.js.map